var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 2C10.4477 2 10 2.44772 10 3V6C10 6.55228 10.4477 7 11 7H13C13.5523 7 14 6.55228 14 6V3C14 2.44772 13.5523 2 13 2H11Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17C10.4477 17 10 17.4477 10 18V21C10 21.5523 10.4477 22 11 22H13C13.5523 22 14 21.5523 14 21V18C14 17.4477 13.5523 17 13 17H11Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 14C2.44772 14 2 13.5523 2 13V11C2 10.4477 2.44772 10 3 10H6C6.55228 10 7 10.4477 7 11V13C7 13.5523 6.55228 14 6 14H3Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 13C17 13.5523 17.4477 14 18 14H21C21.5523 14 22 13.5523 22 13V11C22 10.4477 21.5523 10 21 10H18C17.4477 10 17 10.4477 17 11V13Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22183 7.04991C3.83131 6.65939 3.83131 6.02622 4.22183 5.6357L5.63604 4.22148C6.02657 3.83096 6.65973 3.83096 7.05026 4.22148L9.17158 6.3428C9.5621 6.73333 9.5621 7.36649 9.17158 7.75702L7.75737 9.17123C7.36684 9.56175 6.73368 9.56175 6.34315 9.17123L4.22183 7.04991Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8284 16.2431C14.4379 16.6336 14.4379 17.2668 14.8284 17.6573L16.9497 19.7786C17.3403 20.1691 17.9734 20.1691 18.364 19.7786L19.7782 18.3644C20.1687 17.9739 20.1687 17.3407 19.7782 16.9502L17.6569 14.8289C17.2663 14.4384 16.6332 14.4384 16.2426 14.8289L14.8284 16.2431Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05025 19.7782C6.65972 20.1688 6.02656 20.1688 5.63603 19.7782L4.22182 18.364C3.83129 17.9735 3.83129 17.3403 4.22182 16.9498L6.34314 14.8285C6.73366 14.438 7.36683 14.438 7.75735 14.8285L9.17157 16.2427C9.56209 16.6332 9.56209 17.2664 9.17157 17.6569L7.05025 19.7782Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2426 9.17178C16.6332 9.5623 17.2663 9.5623 17.6569 9.17178L19.7782 7.05046C20.1687 6.65993 20.1687 6.02677 19.7782 5.63625L18.364 4.22203C17.9734 3.83151 17.3403 3.83151 16.9498 4.22203L14.8284 6.34335C14.4379 6.73388 14.4379 7.36704 14.8284 7.75757L16.2426 9.17178Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner6);
export default __webpack_public_path__ + "static/media/spinner-6.b6c5a54d947a3af40b7d73c6471d146f.svg";
export { ForwardRef as ReactComponent };